import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ImageOff } from "lucide-react";

export const AuthImage = ({ path, alt = "", className = "", testId }) => {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let url;
    let alive = true;
    setSrc(null);
    api.get(`/files/${path}`, { responseType: "blob" })
      .then((r) => {
        url = URL.createObjectURL(r.data);
        if (alive) setSrc(url);
      })
      .catch(() => alive && setFailed(true));
    return () => {
      alive = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);

  if (failed) return <div className={`grid place-items-center bg-slate-200 text-slate-500 ${className}`}><ImageOff size={20} /></div>;
  if (!src) return <div className={`animate-pulse bg-slate-300/40 ${className}`} />;
  return <img src={src} alt={alt} className={className} data-testid={testId} />;
};
